module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--13.d9b60bdd.png";